import { render, staticRenderFns } from "./StatisticsCompetences.vue?vue&type=template&id=af8227a6&scoped=true"
import script from "./StatisticsCompetences.vue?vue&type=script&lang=js"
export * from "./StatisticsCompetences.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCompetences.vue?vue&type=style&index=0&id=af8227a6&prod&scoped=true&lang=css"
import style1 from "./StatisticsCompetences.vue?vue&type=style&index=1&id=af8227a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8227a6",
  null
  
)

export default component.exports